<template>
  <ShopifyPackageAdd v-if="SHOPIFYBRANDS.includes(BRAND)"></ShopifyPackageAdd>
  <OpenCartPackageAdd v-else></OpenCartPackageAdd>
</template>

<script>
import { ShopifyPackageAdd, OpenCartPackageAdd } from "./partials";
export default {
  name: "package-add",
  components: { ShopifyPackageAdd, OpenCartPackageAdd }
};
</script>
